import { API_URL } from "../config";
import { authFetch } from "../utils";

export const getSoilSensorData = async ({ soilSensorId, start, end, parameter }) => {
  const url = `${API_URL}soil-sensors/${soilSensorId}/observations?start=${encodeURIComponent(
    start
  )}&end=${encodeURIComponent(end)}&parameter=${parameter}`;

  const response = await authFetch(url);
  if (!response.ok) {
    throw new Error("Error al obtener datos del sensor de suelo");
  }

  const result = await response.json();
  return result;
};
